import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 匿名聊天主頁`,
    languageButtonLabel: `語言`,
    languageModalTitle: `揀語言`,
    languageModalCloseLabel: `收埋語言選單`,
  },
  languageOptions: {
    'en-US': {
      label: `英文 (美國)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英文 (肯亞)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英文 (奈及利亞)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英文 (新加坡)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `葡萄牙文 (葡萄牙)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `葡萄牙文 (巴西)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `德文 (德國)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `德文 (奧地利)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `德文 (瑞士)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `西班牙文 (西班牙)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `法文 (法國)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `義大利文 (意大利)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `荷蘭文 (荷蘭)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `波蘭文 (波蘭)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `瑞典文 (瑞典)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `丹麥文 (丹麥)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `芬蘭文 (芬蘭)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `挪威文 (挪威)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `冰島文 (冰島)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日文 (日本)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韓文 (南韓)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `中文 (中國)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `粵語 (中國香港特別行政區)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `越南文 (越南)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `泰文 (泰國)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `印尼文 (印尼)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `史瓦希里文 (肯亞)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `北印度文 (印度)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `孟加拉文 (孟加拉)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `馬拉地文 (印度)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `泰盧固文 (印度)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `波斯文 (伊朗)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `烏都文 (巴基斯坦)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `旁遮普文 (巴基斯坦)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `尼日利亞皮欽語 (奈及利亞)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `俄文 (俄羅斯)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `阿拉伯文 (沙特阿拉伯)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `阿拉伯文 (阿拉伯聯合大公國)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `阿拉伯文 (卡達)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `摩洛哥阿拉伯文 (摩洛哥)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `土耳其文 (土耳其)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `揀語言`,
    closeLabel: `收埋語言選單`,
  },
  languageHint: (ctx) => `喺 ${ctx.localesCount}+ 種語言之間跳轉，完全唔使開帳戶。`,
  readPagePrompt: ({languageLabel}) => `用${languageLabel}睇呢個頁面。`,
};
